export default "__VITE_ASSET__CJisTC8z__"